import { Component, computed, effect, inject, signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import {
  companyBrandFallbackColor,
  companyInitials,
} from '@core/auth/company-membership-label.util';
import { TenantCompanySwitchService } from '@core/tenant/tenant-company-switch.service';
import { TenantLocationSwitchService } from '@core/tenant/tenant-location-switch.service';

@Component({
  selector: 'app-location-switcher',
  imports: [MaterialModule, TablerIconsModule, TranslateModule],
  templateUrl: './location-switcher.component.html',
  styleUrl: './location-switcher.component.scss',
  host: { class: 'location-switcher-host shrink-0' },
})
export class LocationSwitcherComponent {
  readonly switchService = inject(TenantLocationSwitchService);
  private readonly companySwitch = inject(TenantCompanySwitchService);
  private readonly logoBroken = signal(false);

  /** Logo del negocio (misma fuente que el pill del fill tenant). */
  readonly activeLogoUrl = computed(() => {
    const url = this.companySwitch.activeCompany()?.logoUrl?.trim() || '';
    return this.logoBroken() ? '' : url;
  });

  readonly activeInitials = computed(() => {
    const company = this.companySwitch.activeCompany();
    const location = this.switchService.activeLocation();
    return companyInitials(company?.name || location?.name || '');
  });

  readonly activeBrandColor = computed(() => {
    const company = this.companySwitch.activeCompany();
    if (!company) {
      return '#1f2937';
    }
    return companyBrandFallbackColor(company.id, company.primaryColor);
  });

  readonly displayName = computed(
    () => this.switchService.activeLocation()?.name?.trim() || this.companySwitch.activeCompany()?.name?.trim() || ''
  );

  constructor() {
    effect(() => {
      void this.companySwitch.activeCompany()?.logoUrl;
      this.logoBroken.set(false);
    });
  }

  onLogoError(): void {
    this.logoBroken.set(true);
  }

  selectLocation(locationId: number): void {
    this.switchService.switchLocation(locationId);
  }
}
